/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_O1_Point_0_TextInputs */

const en_visa_o1_point_0_text = /** @type {(inputs: Visa_O1_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We look at the client's full professional story, including recognition, original work, leadership, press, judging, compensation, and comparable evidence where appropriate.`)
};

const pt_visa_o1_point_0_text = /** @type {(inputs: Visa_O1_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisamos a história profissional completa do cliente, incluindo reconhecimento, trabalho original, liderança, imprensa, avaliação, remuneração e evidência comparável quando apropriado.`)
};

const es_visa_o1_point_0_text = /** @type {(inputs: Visa_O1_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizamos la historia profesional completa del cliente, incluyendo reconocimiento, trabajo original, liderazgo, prensa, participación como evaluador, compensación y evidencia comparable cuando corresponda.`)
};

/**
* | output |
* | --- |
* | "We look at the client's full professional story, including recognition, original work, leadership, press, judging, compensation, and comparable evidence wher..." |
*
* @param {Visa_O1_Point_0_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_o1_point_0_text = /** @type {((inputs?: Visa_O1_Point_0_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_O1_Point_0_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_o1_point_0_text(inputs)
	if (locale === "es") return es_visa_o1_point_0_text(inputs)
	return en_visa_o1_point_0_text(inputs)
});